import React, { useEffect } from "react";
import { Mic, Send, Paperclip } from "lucide-react";
import { useSendMessageMutation } from "../redux/apislice";

const ChatInput = ({
  input,
  setInput,
  media,
  setMedia,
  isRecording,
  setIsRecording,
  recorder,
  setRecorder,
  audioBlob,
  setAudioBlob,
}) => {
  const [sendMessage, { isLoading }] = useSendMessageMutation();

  useEffect(() => {
    if (isRecording && !recorder) {
      navigator.mediaDevices.getUserMedia({ audio: true }).then((stream) => {
        const newRecorder = new MediaRecorder(stream);
        const chunks = [];
        newRecorder.ondataavailable = (e) => chunks.push(e.data);
        newRecorder.onstop = () => {
          setAudioBlob(new Blob(chunks, { type: "audio/webm" }));
        };
        newRecorder.start();
        setRecorder(newRecorder);
      });
    } else if (!isRecording && recorder) {
      recorder.stop();
      setRecorder(null);
    }
  }, [isRecording, recorder, setAudioBlob, setRecorder]);

  const handleFileChange = (e) => {
    if (e.target.files[0]) {
      setMedia(e.target.files[0]);
    }
  };

  const handleSend = async () => {
    if (!input.trim()) return;

    try {
      const response = await sendMessage({
        userId: 1,
        text: input.trim(),
      }).unwrap();

      console.log("Message sent:", response);
      setInput(""); 
    } catch (error) {
      console.error("Error sending message:", error);
    }
  };

  const handleKeyDown = (e) => {
    if (e.key === "Enter" && !e.shiftKey) {
      e.preventDefault();
      handleSend();
    }
  };

  return (
    <div className="p-4 flex items-center gap-2 border-t bg-white">
      <input
        type="file"
        onChange={handleFileChange}
        className="hidden"
        id="file-upload"
      />
      <label htmlFor="file-upload">
        <Paperclip className="w-5 h-5 text-gray-500 cursor-pointer" />
      </label>

      <textarea
        value={input}
        onChange={(e) => setInput(e.target.value)}
        onKeyDown={handleKeyDown}
        placeholder="Type a message..."
        rows={1}
        className="flex-1 p-2 border rounded-lg resize-none text-sm"
      />

      <button
        onClick={() => setIsRecording(!isRecording)}
        className={`p-2 rounded-full transition ${
          isRecording ? "bg-red-100 text-red-500" : "hover:bg-gray-100"
        }`}
      >
        <Mic className="w-5 h-5" />
      </button>

      <button
        onClick={handleSend}
        disabled={isLoading}
        className="bg-blue-500 text-white px-3 py-2 rounded-lg hover:bg-blue-600 disabled:opacity-50"
      >
        <Send className="w-4 h-4" />
      </button>
    </div>
  );
};

export default ChatInput;
